// extracted by mini-css-extract-plugin
export default {"cardHead":"ActiveCustomers_cardHead__2fa1U","cardTitle":"ActiveCustomers_cardTitle__x0+ze","chart":"ActiveCustomers_chart__PAeKA"};